import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Spacer,
  Button,
  Tag,
  TextArea,
  Modal,
  ModalBody,
  ModalFooter,
  // Checkbox,
} from '@flexisaf/flexibull2';
import Theme from 'utils/theme';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  processApplicantStage,
  // notifyApplicants,
} from 'redux/applicants/actions';
import LocationPosting from './LocationPosting';
import { orgBranches } from 'redux/configurations/selectors';
import { selectTemplate } from 'redux/template/selectors';
import { StepsWithNotify } from 'components/WorkflowSteps/utils';
import TemplateViewer from '../templateViewer';

const ChangeStatusModal = ({
  changeStatus,
  handleModal,
  applicant,
  stageToProcess,
  application,
  course,
  closeModals,
  setRefetchCandidates,
  workflowDetails,
}) => {
  const dispatch = useDispatch();
  const branches = useSelector(orgBranches);
  const templates = useSelector(selectTemplate);
  const { email, document } = templates;

  const [comment, setComment] = useState('');
  const [location, setLocation] = useState(null);
  const [processing, setProcessing] = useState(false);
  // const [autoNotify, setAutoNotify] = useState(false);

  useEffect(() => {
    if (applicant?.location?.id) {
      setLocation({
        label: `${applicant?.location?.name}`,
        value: applicant?.location.id,
      });
    }
  }, [applicant]);

  const changeApplicantStage = () => {
    setProcessing(true);
    const filters = {
      applicationId: application.id,
      course,
    };
    dispatch(
      processApplicantStage(
        { ...applicant, comment, locationId: location?.value || '' },
        stageToProcess?.id,
        filters,
        () => {
          setComment('');
          closeModals();
          setProcessing(false);
          setRefetchCandidates(true);
        }
      )
    );
    // if (autoNotify) {
    //   dispatch(
    //     notifyApplicants(
    //       {
    //         applicants: [applicant?.id],
    //         id: application?.id,
    //         stepId: stageToProcess?.id,
    //       },
    //       () => null
    //     )
    //   );
    // }
  };

  const checkStage = () => <Text bold>{stageToProcess?.name}</Text>;

  const checkTemplate = () => {
    const templateArr = [];
    const findMatchingTemplate = workflowDetails.steps?.find((apw) => apw.id === stageToProcess?.id);
    const findMatchingUserEmailTemplate = email?.user?.content?.find((emailTemplate) => emailTemplate?.name?.toLowerCase() === findMatchingTemplate?.emailTemplate?.toLowerCase());
    const findMatchingUserDocTemplate = document?.user?.content?.find((docTemplate) => docTemplate?.name?.toLowerCase() === findMatchingTemplate?.pdfTemplate?.toLowerCase());
    if (findMatchingUserEmailTemplate) { templateArr.push(findMatchingUserEmailTemplate) };
    if (findMatchingUserDocTemplate) { templateArr.push(findMatchingUserDocTemplate) }
    return templateArr;
  }

  return (
    <Modal open={changeStatus}>
      <ModalBody width="650px">
        <Box pad="30px 30px 0" display="flex">
          <Tag
            color="transparent"
            solid
            fontColor={Theme.PrimaryRed}
            height={45}
            pad="0 15px 0 0"
            font="40px"
          >
            <i className="saf-warning" />
          </Tag>
          <Text block>
            <Text block size="25px">
              Change Applicants Status
            </Text>
            <Spacer space="4px" />
            <Text block size="10px">
              Process applicants by their stage
            </Text>
          </Text>
        </Box>
        <Box pad="15px 40px 40px">
          <Box background="#ccc" height="1px" />
          <Spacer space="20px" />
          <Text>
            You are about to change{' '}
            <Text bold>
              {applicant?.firstName} {applicant?.middleName}{' '}
              {applicant?.lastName}
            </Text>{' '}
            application status to {checkStage()}, Please comment the reason for
            the applicants status change and then continue.
          </Text>
          <Spacer space="50px" />
          {branches.data.length > 0 && (
            <LocationPosting location={location} handleChange={setLocation} />
          )}
          <Spacer space="35px" />
          <TextArea
            name="Comment"
            required
            placeholder="Please comment reason for applicant's status change"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            width="100%"
            label="Comment"
            height="100px"
          />
          <Spacer space="24px" />
          {/* {StepsWithNotify.includes(stageToProcess?.type) && (
            <Checkbox
              label={
                <>
                  <Text bold>Send notification </Text>
                  <Text>{`(if selected, candidate would be notified)`}</Text>
                </>
              }
              spaceLeft="-10px"
              elevate="high"
              checked={autoNotify}
              onChange={() => setAutoNotify(!autoNotify)}
            />
          )} */}
          {StepsWithNotify.includes(stageToProcess?.type) && <TemplateViewer templates={checkTemplate()} />}
        </Box>
        <ModalFooter>
          <Box
            width="100%"
            display="flex"
            pad="25px 40px"
            style={{ justifyContent: 'space-between' }}
          >
            <Button
              onClick={() => handleModal(false)}
              color="transparent"
              pale
              fontColor={Theme.PrimaryRed}
            >
              Cancel
            </Button>
            <Button
              bold
              spaceLeft="15px"
              disabled={!comment}
              progress={!comment ? false : processing}
              onClick={() => changeApplicantStage()}
            >
              Comment & Proceed
            </Button>
          </Box>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
};

export default ChangeStatusModal;

ChangeStatusModal.propTypes = {
  changeStatus: PropTypes.bool,
  handleModal: PropTypes.func,
  applicant: PropTypes.object,
  stageToProcess: PropTypes.object,
  application: PropTypes.object,
  course: PropTypes.object,
  closeModals: PropTypes.func,
  setRefetchCandidates: PropTypes.bool,
  workflowDetails: PropTypes.object,
};
